import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


declare var $;

@Component({
	selector: 'itm-modal',
	templateUrl: './itm-modal.component.html',
	styleUrls: ['./itm-modal.component.scss']
})
export class ItmModalComponent implements OnInit {

	@Input() cssClass: string = "fade";
	@Input() backdrop: string = "static";
	@Input() id: string;
	@Input() cssClassModalDialog: string = "modal-dialog-centered"
	@Input() cssClassModalSize: string = "";

	@Output() onShow: EventEmitter<any> = new EventEmitter<any>();
	@Output() onHide: EventEmitter<any> = new EventEmitter<any>();

	showCssClass: string = "";

	constructor() { }

	ngOnInit() {
	}

	show() {
		this.showCssClass = "show";
		$("body").addClass("modal-open");
		$("#modal-backdrop").removeClass("d-none");
		this.onShow.emit();
	}

	hide() {
		this.showCssClass = "";
		$("body").removeClass("modal-open");
		$("#modal-backdrop").addClass("d-none");
		this.onHide.emit();
	}

}
